import { Link } from "react-router-dom";
import { CATEGORIES, CALCULATORS } from "@/data/calculators";
import A11ySettings from "@/components/A11ySettings";
import TrustBadge from "@/components/TrustBadge";

export default function Footer() {
    const year = new Date().getFullYear();
    return (
        <footer className="mt-24 border-t border-border bg-card/50">
            <div className="container-editorial py-16">
                <div className="grid grid-cols-2 md:grid-cols-5 gap-8">
                    <div className="col-span-2">
                        <div className="font-serif text-3xl text-primary">
                            Fin<span className="text-accent">Calc</span>
                        </div>
                        <p className="mt-3 text-sm text-muted-foreground max-w-sm leading-relaxed">
                            Straightforward money math. Free, accurate, and always here —
                            because the biggest decisions of your life shouldn&apos;t require a
                            spreadsheet.
                        </p>
                        <div className="mt-5">
                            <TrustBadge />
                        </div>
                        <div className="mt-5 text-xs text-muted-foreground leading-relaxed">
                            FinCalc is a product of <strong className="text-primary">Hi Tex Lawn Pro LLC</strong>.
                            Also from us:{" "}
                            <a
                                href="https://getturfpulse.com"
                                target="_blank"
                                rel="me noopener"
                                data-testid="sister-site-turfpulse"
                                className="text-primary hover:text-secondary underline-offset-2 hover:underline"
                            >
                                TurfPulse — smart lawn care powered by Growing Degree Days
                            </a>.
                        </div>
                        <p className="mt-6 text-[11px] text-muted-foreground">
                            © {year} FinCalc · a product of Hi Tex Lawn Pro LLC. All calculators are for informational purposes only and
                            are not financial advice. Consult a licensed professional before acting.
                        </p>
                    </div>

                    {Object.values(CATEGORIES).map((c) => (
                        <div key={c.id}>
                            <div className="text-[10px] uppercase tracking-[0.2em] text-primary/70 mb-3 font-medium">
                                {c.label}
                            </div>
                            <ul className="space-y-2">
                                {CALCULATORS.filter((x) => x.category === c.id).map((t) => (
                                    <li key={t.slug}>
                                        <Link
                                            to={`/calculator/${t.slug}`}
                                            data-testid={`footer-link-${t.slug}`}
                                            className="text-sm text-foreground/75 hover:text-primary transition-colors"
                                        >
                                            {t.short}
                                        </Link>
                                    </li>
                                ))}
                            </ul>
                        </div>
                    ))}
                </div>

                <div className="mt-12 pt-6 border-t border-border flex flex-col sm:flex-row gap-4 sm:items-center sm:justify-between">
                    <div className="flex flex-wrap gap-x-6 gap-y-2 text-sm">
                        <Link to="/about" data-testid="footer-about" className="text-foreground/80 hover:text-primary">About</Link>
                        <Link to="/blog" data-testid="footer-blog" className="text-foreground/80 hover:text-primary">Blog</Link>
                        <Link to="/trust" data-testid="footer-trust" className="text-foreground/80 hover:text-primary">Trust</Link>
                        <Link to="/privacy" data-testid="footer-privacy" className="text-foreground/80 hover:text-primary">Privacy</Link>
                        <Link to="/terms" data-testid="footer-terms" className="text-foreground/80 hover:text-primary">Terms</Link>
                        <Link to="/accessibility" data-testid="footer-accessibility" className="text-foreground/80 hover:text-primary">Accessibility</Link>
                        <Link to="/contact" data-testid="footer-contact" className="text-foreground/80 hover:text-primary">Contact</Link>
                    </div>
                    <div className="flex items-center gap-3">
                        <A11ySettings />
                        <p className="text-[11px] text-muted-foreground tabular hidden md:block">
                            Built for anyone making a real money decision today.
                        </p>
                    </div>
                </div>
            </div>
        </footer>
    );
}
